import { onMounted, onUnmounted } from "vue";
import { useLinkEditContext } from "./useLinkEditContext";

export function useSetLinkEditContextSubmitHandler(submitHandler: () => Promise<void> | void) {
  const linkEditContext = useLinkEditContext();

  onMounted(() => {
    linkEditContext?.setSubmitHandler(submitHandler);
  });

  onUnmounted(() => {
    linkEditContext?.clearSubmitHandler();
  });
}
